/* tslint:disable */
/* eslint-disable */
/**
 * MedicalOperations API
 * This is an OpenAPI for the MedicalOperations Microservice
 *
 * OpenAPI spec version: 0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 * 
 *
 * @export
 * @interface CreateNewTemplateRequestFields
 */
export interface CreateNewTemplateRequestFields {

    /**
     * @type {string}
     * @memberof CreateNewTemplateRequestFields
     */
    FieldName?: string;

    /**
     * @type {string}
     * @memberof CreateNewTemplateRequestFields
     * @example string
     */
    DataType?: CreateNewTemplateRequestFieldsDataTypeEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum CreateNewTemplateRequestFieldsDataTypeEnum {
    Text = 'Text',
    Number = 'Number',
    YesNo = 'Yes/No',
    Date = 'Date'
}

